import React, {useRef, useState} from 'react';
import {DatePicker, Select, Space, Table, Tag, Typography} from 'antd';
import ENDPOINTS from '../../constants/endpoints';
import SearchTable from '../../components/admin/SearchTable';
import {dateFormat} from '../../utils/utils';
import {AUDIT_ACTION_COLOR} from '../../utils/colors';

const {RangePicker} = DatePicker;

const MODULE_OPTIONS = [
    {value: '', label: 'Todos os módulos'},
    {value: 'faq', label: 'FAQ'},
    {value: 'news', label: 'Blog'},
    {value: 'ecommerce', label: 'Ecommerce'},
    {value: 'site_config', label: 'Configurações do Site'},
    {value: 'authentication', label: 'Equipe'},
];

const ACTION_OPTIONS = [
    {value: '', label: 'Todas as ações'},
    {value: 'CREATE', label: 'Criação'},
    {value: 'UPDATE', label: 'Atualização'},
    {value: 'DELETE', label: 'Remoção'},
];

const ACTION_LABEL = {
    CREATE: 'Criação',
    UPDATE: 'Atualização',
    DELETE: 'Remoção',
};

const changesColumns = [
    {title: 'Campo', dataIndex: 'field', key: 'field'},
    {
        title: 'Valor anterior',
        dataIndex: 'old',
        key: 'old',
        render: (value) => (value === null || value === undefined || value === '' ? '-' : String(value)),
    },
    {
        title: 'Valor novo',
        dataIndex: 'new',
        key: 'new',
        render: (value) => (value === null || value === undefined || value === '' ? '-' : String(value)),
    },
];

export default function AdminAuditLogList() {
    const tableRef = useRef();
    const [moduleFilter, setModuleFilter] = useState('');
    const [actionFilter, setActionFilter] = useState('');
    const [dateRange, setDateRange] = useState(null);

    const columns = [
        {
            title: 'Data/Hora',
            dataIndex: 'created_at',
            key: 'created_at',
            render: (value) => dateFormat(value, 'DD/MM/YYYY HH:mm:ss'),
        },
        {
            title: 'Usuário',
            key: 'user',
            render: (_, record) => record.user_name || record.user_email || 'Sistema',
        },
        {
            title: 'Ação',
            dataIndex: 'action',
            key: 'action',
            render: (action) => (
                <Tag color={AUDIT_ACTION_COLOR[action] ?? 'default'}>
                    {ACTION_LABEL[action] ?? action}
                </Tag>
            ),
        },
        {
            title: 'Módulo',
            key: 'module',
            render: (_, record) => `${record.module} · ${record.model_name}`,
        },
        {
            title: 'Objeto',
            dataIndex: 'object_repr',
            key: 'object_repr',
        },
        {
            title: 'IP',
            dataIndex: 'ip_address',
            key: 'ip_address',
            render: (value) => value || '-',
        },
    ];

    const expandable = {
        rowExpandable: (record) => Object.keys(record.changes || {}).length > 0,
        expandedRowRender: (record) => (
            <Table
                size="small"
                pagination={false}
                rowKey="field"
                dataSource={Object.entries(record.changes || {}).map(([field, diff]) => ({
                    field,
                    old: diff?.old,
                    new: diff?.new,
                }))}
                columns={changesColumns}
            />
        ),
    };

    const [dateFrom, dateTo] = dateRange || [];
    const filterParams = {};
    if (moduleFilter) filterParams.module = moduleFilter;
    if (actionFilter) filterParams.action = actionFilter;
    if (dateFrom) filterParams.date_from = dateFrom.format('YYYY-MM-DD');
    if (dateTo) filterParams.date_to = dateTo.format('YYYY-MM-DD');

    return (
        <>
            <Space style={{marginBottom: 16}} wrap>
                <Typography.Text strong>Módulo:</Typography.Text>
                <Select
                    value={moduleFilter}
                    onChange={setModuleFilter}
                    options={MODULE_OPTIONS}
                    style={{width: 220}}
                />
                <Typography.Text strong>Ação:</Typography.Text>
                <Select
                    value={actionFilter}
                    onChange={setActionFilter}
                    options={ACTION_OPTIONS}
                    style={{width: 180}}
                />
                <Typography.Text strong>Período:</Typography.Text>
                <RangePicker
                    value={dateRange}
                    onChange={setDateRange}
                    format="DD/MM/YYYY"
                    allowClear
                />
            </Space>

            <SearchTable
                key={`${moduleFilter}-${actionFilter}-${dateFrom?.format('YYYY-MM-DD') || ''}-${dateTo?.format('YYYY-MM-DD') || ''}`}
                ref={tableRef}
                url={ENDPOINTS.AUDIT_LOG_LIST}
                params={filterParams}
                columns={columns}
                title="Logs de Auditoria"
                expandable={expandable}
            />
        </>
    );
}
